var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0026 14.6663C4.3206 14.6663 1.33594 11.6817 1.33594 7.99967C1.33594 4.31767 4.3206 1.33301 8.0026 1.33301C11.6846 1.33301 14.6693 4.31767 14.6693 7.99967C14.6693 11.6817 11.6846 14.6663 8.0026 14.6663ZM8.0026 7.05701L6.11727 5.17101L5.17394 6.11434L7.05994 7.99967L5.17394 9.88501L6.11727 10.8283L8.0026 8.94234L9.88794 10.8283L10.8313 9.88501L8.94527 7.99967L10.8313 6.11434L9.88794 5.17101L8.0026 7.05701Z",
    fill: "#FF4949"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtn);
export default __webpack_public_path__ + "static/media/closeBtn.3607fdb6157c2d97303cfcaab18f8ecd.svg";
export { ForwardRef as ReactComponent };